import events from "../events"
import { LocalizationEventName, LocaleCodeChangeCallback } from "./types"

const localizationEventsNamespace = 'localization'

export const localizationEvents = {
    trigger(eventName: LocalizationEventName, newLocalCode: string, oldLocaleCode: string) {
        events.trigger(localizationEventsNamespace + '.' + eventName, newLocalCode, oldLocaleCode)
    },

    onChange(eventName: LocalizationEventName, callBack: LocaleCodeChangeCallback) {
        return events.on(localizationEventsNamespace + '.' + eventName, callBack)
    }
}